module.exports = __webpack_public_path__ + "static/media/trailer_blue.463c5295.svg";